import { apiUri } from "../../../config";
import axios from "axios";
import { padCalendar } from "../../../util";

export const LOAD_CASES = "LOAD_CASES";

export const LOAD_UPDATED_CASES = "LOAD_UPDATED_CASES";

export const LOAD_COMMISSION_INFO = "LOAD_COMMISSION_INFO";

export const LOAD_CASE_NOTES_INFO = "LOAD_CASE_NOTES_INFO";

const receivedPageOfCases = (cases, page) => {
	const convertedCases = cases.content.map(c => {
		c.dateFiled = padCalendar(c.dateFiled);
		c.classPeriodStart = padCalendar(c.classPeriodStart);
		c.classPeriodEnd = padCalendar(c.classPeriodEnd);
		c.nextTradingDay = padCalendar(c.nextTradingDay);
		return {
			fillingName: c.caseName,
			fillingDate: c.dateFiled,
			classPeriodStart: c.classPeriodStart,
			classPeriodEnd: c.classPeriodEnd,
			ticker: c.symbol,
			caseId: c.caseId,
			purchased: c.purchased,
			docketId: c.docketId,
			sicCode: c.sicCode,
			cik: c.cik,
			market: c.market,
			docketNotes:c.docketNotes,
			nextTradingDay:c.nextTradingDay,
			settlementValue:c.settlementValue,
			enabled: c.enabled,
			caseFile: c.caseFile,
			complaintFile: c.complaintFile,
			identifier: c.identifier,
			approxMarketCapLoss: c.approxMarketCapLoss,
			amendClaimsType: c.amendClaimsType,
			settlementStatus: c.settlementStatus,
			caseRuleType: c.caseRuleType,
			s3URL: c.s3URL
		};
	});
	return {
		type: LOAD_CASES,
		cases: convertedCases,
		totalCases: cases.total,
		totalPages: cases.totalPages,
		currentPage: page
	};
};

export const searchData = page => {
 
	let pageNo = page;
	let searchData = JSON.parse(localStorage.getItem("searchValue"));
	var search = "";
	if (searchData) {
		search = searchData;
	}
	return dispatch => {
		axios
			.get(
				apiUri +
					"/cases?page=" +
					pageNo +
					"&search=" +
					search +
					"&sortField=&order="
			)
			.then(json => {
				if (
					json !== undefined &&
					json.data !== undefined &&
					json.data.content !== undefined
				) {
					dispatch(receivedPageOfCases(json.data, page));
				}
			})
			.catch(err => {
				console.log(err);
			});
	};
};
export const searchSortData = (page, sortKey, sortOrder) => {
	
	let pageNo = page;
	let searchData = JSON.parse(localStorage.getItem("searchValue"));
	var search = "";
	if (searchData) {
		search = searchData;
	}
	return dispatch => {
		axios
			.get(
				apiUri +
					"/cases?page=" +
					pageNo +
					"&search=" +
					search +
					"&sortField=" +
					sortKey +
					"&order=" +
					sortOrder
			)
			.then(json => dispatch(receivedPageOfCases(json.data, page)))
			.catch(err => {
				console.log(err);
			});
	};
};

export const requestPageOfCases = (page, sortKey, sortOrder) => {
	let searchData = JSON.parse(localStorage.getItem("searchValue"));
	let sortData = JSON.parse(localStorage.getItem("sortParams"));

	var search = "";
	sortKey = "";
	sortOrder = "";
	if (searchData) {
		search = searchData;
	}
	if (sortData) {
		sortKey = sortData.sortValue;
		sortOrder = sortData.sortOrder;
	}
	return dispatch => {
		axios
			.get(
				apiUri +
					"/cases?page=" +
					page +
					"&search=" +
					search +
					"&sortField=" +
					sortKey +
					"&order=" +
					sortOrder
			)
			.then(json => dispatch(receivedPageOfCases(json.data, page)))
			.catch(err => {
				console.log(err);
			});
	};
};

export const getCommissionInfoBtId = Id => {
	return dispatch => {
		axios
			.get(apiUri + "/commissions/CommissionInfo/" + Id)
			.then(res =>{
			 
				dispatch({
					type: LOAD_COMMISSION_INFO,
					CommissionInfo: res.data
				})
			}
			)
			.catch(err => {
				console.log(err);
			});
	};
};
export const getCaseNotesById = Id => {
	return dispatch => {
		axios
			.get(apiUri + "/cases/"+Id+"/caseNotes/")
			.then(res =>{
			 
				dispatch({
					type: LOAD_CASE_NOTES_INFO,
					txtCaseNotes: res.data.data
				})
			})
			.catch(err => {
				console.log(err);
			});
	};
};


// WEBPACK FOOTER //
// ./src/components/CaseSelector/store/actions.js